module.exports = __webpack_public_path__ + "static/antd-image-default-7a3d0e792cd8fa47fb254e123df378fb.png";